// ** Redux & Store & Actions
import { useSelector } from "react-redux";

// ** Third Party Components
import loadable from "@loadable/component";

// ** Custom Components
import Section from "components/layout/Section";
import Paragraph from "components/typography/Paragraph";
import Seo from "./Seo";
import Block from "components/layout/Block";

// ** Loadable Components
import AboutUsSectionServer from "./AboutUsSection_Server";
const AboutUsSectionClient = loadable(() => import("./AboutUsSection_Client"), {
	ssr: false,
});
import { NewsSection } from "./NewsSection";

// #####################################################

const AboutUsSection = () => {
	const isClient = useSelector((state) => state.globalCommon.isClient);

	// #####################################################

	return (
		<Section customMobilePadding="1rem 2rem">
			<Seo />

			<NewsSection />

			<Paragraph size="1.5rem" textCenter bold mt={12} mb={10}>
				W opinii użytkowników Datezone.com to najlepsze sex randki w
				Polsce!
			</Paragraph>

			<Block>
				{isClient ? <AboutUsSectionClient /> : <AboutUsSectionServer />}
			</Block>
		</Section>
	);
};

export default AboutUsSection;
